/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#1A1A1A";
export const ColorTextSecondary = "#1A1A1A";
export const ColorBackgroundPrimary = "#F7F8FB";
export const ColorBackgroundSecondary = "#EBECF5";
export const ColorIconPrimary = "#000000";
export const ColorIconSecondary = "#000000";
